import {
  FormControlLabel,
  FormGroup,
  Checkbox,
  Grid,
  TextField,
  Box,
  FormControl,
  MenuItem,
  Button,
  FormHelperText,
  Typography,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import { React, useRef, useEffect, useState } from "react";

import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import BackButton from "../../common/button/backButton";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import { useDispatch, useSelector } from "react-redux";

import CreateMasterModal from "../masterForm/modals/createMasterModal";
import capRegistrationActions from "../../redux/capRegistration/actions";
import { IoCloseCircleOutline } from "react-icons/io5";

export default function AddCapCourseDocument() {
  const navigate = useNavigate();
  const location = useLocation();
  let id = location?.state?.id;

  const dispatch = useDispatch();

  const {} = useSelector((state) => state.masterFormsReducer);
  const { capDocuments } = useSelector((state) => state.capReducer);

  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const [uploadfile, setUploadedFile] = useState(null);
  const [message, setMessage] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [isViewEnabled, setIsViewEnabled] = useState(false);

  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    trigger,
    control,
    setError,
    resetField,
    clearErrors,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (id && capDocuments?.length > 0) {
      let data = capDocuments?.find((obj) => obj.documenttypeid == id);
      console.log(data, id, capDocuments);
      reset({
        ...data,
      });

      setFile(data?.sampleurl);

      if (data?.sampleurl && data.sampleurl !== "null") {
        setFileName(data.sampleurl.split("/").pop());
      }
    }
  }, [capDocuments, id, reset]);

  useEffect(() => {
    if (location.search === "?page=updatecapcoursedocument") {
      dispatch({
        type: capRegistrationActions.GET_CAP_COURSE_DOCUMENT,
      });
    }
  }, []);

  useEffect(() => {
    if (
      location.search === "?page=updatecapcoursedocument" &&
      id &&
      capDocuments?.length > 0
    ) {
      const currentDoc = capDocuments?.find((obj) => obj.documenttypeid == id);
      setIsViewEnabled(
        !!(currentDoc?.sampleurl && currentDoc.sampleurl !== "null")
      );
    } else {
      setIsViewEnabled(Boolean(uploadfile));
    }
  }, [capDocuments, id, uploadfile, location.search]);

  const resetForm = () => {
    reset({});
  };

  useEffect(() => {
    if (id) {
      let { prerequisite, ...course } =
        capDocuments?.all?.find((obj) => obj.documenttypeid === id) || {};

      setValue(
        "sampleurl",
        course?.sampleurl === "null" ? "" : capDocuments?.sampleurl
      );
    }
  }, [setValue, capDocuments, id]);

  // const handleFileUpload = (e) => {
  //   setMessage("");
  //   const uploadedFile = e.target.files[0];
  //   setUploadedFile(e.target.files[0]);
  //   setFile(uploadedFile);
  //   setFileName(uploadedFile ? uploadedFile.name : "");
  // };

  const handleFileUpload = (e) => {
    setMessage("");
    const uploadedFile = e.target.files[0];

    if (uploadedFile) {
      setUploadedFile(uploadedFile);
      setFileName(uploadedFile.name);

      const blobUrl = URL.createObjectURL(uploadedFile);
      setFile(blobUrl);
    }
  };

  const handleAddCapCourseDocument = (data) => {
    data["userid"] = backofficeTokenDetails?.id;

    dispatch({
      type: capRegistrationActions.CREATE_CAP_COURSE_DOCUMENT,
      payload: {
        data: data,
        sampleurl: uploadfile,
        navigate: navigate,
        resetForm: resetForm,
      },
    });
  };

  const handleUpdateCapCourseDocument = (data) => {
    data["userid"] = backofficeTokenDetails?.id;

    if (!uploadfile && file && typeof file === "string") {
      data["sampleurl"] = file;
    }

    dispatch({
      type: capRegistrationActions.UPDATE_CAP_COURSE_DOCUMENT,
      payload: {
        data: data,
        sampleurl: uploadfile,
        navigate: navigate,
        resetForm: resetForm,
      },
    });
  };

  const handleViewClick = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    const isUpdateMode = location.search === "?page=updatecapcoursedocument";

    if (isUpdateMode && id && capDocuments?.length > 0) {
      const currentDoc = capDocuments?.find((obj) => obj.documenttypeid == id);
      setIsViewEnabled(
        !!(currentDoc?.sampleurl && currentDoc.sampleurl !== "null") ||
          Boolean(uploadfile)
      );
    } else {
      setIsViewEnabled(Boolean(uploadfile));
    }
  }, [capDocuments, id, uploadfile, location.search]);

  return (
    <>
      <Grid container spacing={3} mb={3} mt={2}>
        <Grid item xs={12} md={8}>
          <TextField
            sx={{ marginLeft: "23px" }}
            {...register("documenttype", {
              required: "Cap Course Document Name is required",
            })}
            InputLabelProps={{
              shrink: !!watch("documenttype"),
            }}
            error={!!errors.documenttype}
            helperText={errors.documenttype?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                CAP Course Document Name
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>

        <Grid item md={6} xs={12} mt={1}>
          <TextField
            multiline
            name="coursenotes"
            {...register("coursenotes")}
            label="Course Notes"
            placeholder="Enter Course Notes"
            fullWidth
            rows={4}
            error={!!errors.coursecategoryid}
            helperText={errors.coursecategoryid?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            InputLabelProps={{
              shrink: !!watch("coursenotes"),
            }}
            sx={{ width: "135%", marginLeft: "4%" }}
          />
        </Grid>

        <Grid container spacing={3} mb={3} mt={2}>
          <Grid item xs={12} md={8} sx={{ marginLeft: "42px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "5px",
                position: "relative",
              }}
            >
              <TextField
                sx={{ width: "100%" }}
                label={
                  <span>
                    Upload CAP Course Document
                    <span className="error" style={{ color: "red" }}>
                      {" "}
                      *
                    </span>
                  </span>
                }
                type="text"
                value={fileName || "No file chosen"}
                fullWidth
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <label
                      htmlFor="file-input"
                      style={{
                        cursor: "pointer",
                        color: "#1976d2",
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: 1,
                      }}
                    >
                      Choose File
                    </label>
                  ),
                }}
                error={!!errors.uploadfile}
                helperText={errors.uploadfile?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
              />
              <input
                type="file"
                accept=".pdf"
                onChange={handleFileUpload}
                style={{ display: "none" }}
                id="file-input"
              />
              <Button
                variant="contained"
                size="small"
                style={{
                  marginLeft: "8px",
                  height: "40px",
                }}
                onClick={handleViewClick}
                disabled={!isViewEnabled}
              >
                View
              </Button>
            </div>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        md={12}
        sx={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
      >
        <BackButton
          handleBack={() =>
            navigate(
              `/${Cookies.get(
                "mhet_mst_project"
              )}/cap-course-document-master?page=document-list`
            )
          }
        />
        <BluePrimaryButton
          handleSubmit={handleSubmit(
            location.search !== "?page=updatecapcoursedocument"
              ? handleAddCapCourseDocument
              : handleUpdateCapCourseDocument
          )}
          title={
            location.search === "?page=updatecapcoursedocument"
              ? "Update"
              : "Submit"
          }
        />
      </Grid>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          View Document
          <IconButton
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 10,
              top: 10,
              color: "#212121",
            }}
          >
            <IoCloseCircleOutline size={30} style={{ color: "red" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {file && file !== "null" ? (
            <iframe
              src={file}
              width="100%"
              height="600px"
              title="Document Preview"
            ></iframe>
          ) : (
            <Typography variant="body1">No document available</Typography>
          )}
        </DialogContent>
      </Dialog>
      <CreateMasterModal
        // trigger={trigger}
        getValues={getValues}
        register={register}
        // handleSubmit={handleSubmit}
        errors={errors}
        resetForm={resetForm}
        watch={watch}
      />
    </>
  );
}
